import { useEffect, useState } from "react";
import { Grid2, Typography, Button, Box, TextField } from "@mui/material";
import NumOtpStyles from "../SignUpPhOtp.module.css";
import SignUpBg from "../../../../Assets/Images/Signup_web.png";
import { useDispatch, useSelector } from "react-redux";
import { generateMobileOtp, setuserData, verifyMobileOtp, setRetakeError } from "../../../../Redux/usersSlice";
import { useNavigate } from "react-router-dom";
import Logo from '../../../../Assets/Images/logo.svg';
import errorIcon from "../../../../Assets/Images/alert.gif"

export default function ReatakeNumOtp() {

    const [otp, setOtp] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, userData, retakeError, retakeAuth, retakeToken } = useSelector(state => state.user);

    const [clientErr, setClientErr] = useState("")
    const [timeLeft, setTimeLeft] = useState(20);


    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "retake_mobile_otp_page_viewed",
            page_path: window.location.pathname
        });
        if (!retakeToken) {
            dispatch(setRetakeError("Authorization failed: Token not provided."))
        }
    }, []);


    useEffect(() => {
        if (timeLeft <= 0) return;
        const timer = setInterval(() => {
            setTimeLeft(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);



    const handleChange = (e, index) => {
        const value = e.target.value;
        if (/^[0-9]*$/.test(value) && value.length <= 1) {
            const newOtp = otp.split("");
            newOtp[index] = value;
            const updatedOtp = newOtp.join("");
            console.log("updatedOtp", updatedOtp, updatedOtp.length === 4)
            setOtp(updatedOtp);


            if (value && index < 4) {
                const nextInput = document.getElementById(`otp-${index + 1}`);
                if (nextInput) nextInput.focus();
            }

            if (updatedOtp.length === 4) {
                console.log("OTP entered:", updatedOtp);
                handleOtpSubmit(updatedOtp);
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            const prevInput = document.getElementById(`otp-${index - 1}`);
            if (prevInput) prevInput.focus();
        }
    };

    const handleOtpSubmit = async (updatedOtp) => {
        // e.preventDefault();
        if (updatedOtp.length !== 4) {
            setClientErr("Please Enter Otp")
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "mobile_otp_entered",
            page_path: window.location.pathname
        });

        console.log(
            {
                mobile: retakeAuth?.mobile,
                otp: updatedOtp
            }
        )

        try {
            const response = await dispatch(verifyMobileOtp({
                mobile: retakeAuth?.mobile,
                otp: updatedOtp
            })).unwrap();
            if (response.data?.success) {
                if (retakeAuth?.step == "selfie") {
                    navigate("/selfie-retake")
                } else if (retakeAuth?.step == "signature") {
                    navigate("/signature-retake")
                }
            } else if (response.data?.message === "Invalid mobile otp") {
                setClientErr("Invalid mobile otp")
            } else if (response.data?.message === "Please provide valid mobile or otp") {
                setClientErr("Please provide valid mobile or otp")
            } else if (response.data?.message === "Mobile Otp already verified") {
                setClientErr("Mobile Otp already verified")
            }
            else if (response.data?.message === "OTP expired, please request a new one") {
                setClientErr("OTP expired, please request a new one")
            }
        } catch (error) {
            console.error('OTP verification failed:', error);
            setClientErr(error?.data?.data?.message || "OTP verification failed")
        }
    };

    const handleResendOtp = async (e) => {
        e.preventDefault();

        try {
            const response = await dispatch(
                generateMobileOtp({ mobile: retakeAuth?.mobile, referral_code: localStorage.getItem("refCode") || "" })
            ).unwrap();

            if (response.data?.success) {

                setTimeLeft(20);
                setClientErr("");


                if (response.data?.user) {
                    dispatch(setuserData(response.data?.user));
                }

            } else if (response.data?.message) {
                setClientErr(response.data.message);
            }

        } catch (error) {
            console.error("Resend OTP failed:", error);
            setClientErr(error?.data?.data?.message || "Something went wrong, please try again");
        }
    };

    return (
        <>

            {
                retakeError ? <Grid2
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: `url(${SignUpBg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        "@media (max-width:600px)": {
                            justifyContent: "start"
                        }
                    }}
                > <Box
                    sx={{
                        position: "absolute",
                        top: "35%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",

                        width: {
                            xs: "70%",
                            sm: "60%",
                            md: "40%",
                        },

                        bgcolor: "background.paper",
                        borderRadius: 5,
                        boxShadow: 24,
                        p: 3,
                        textAlign: "center",
                        // m:2
                        "@media (max-width:600px)": {
                            top: "45%",
                            p: 3,
                        }
                    }}
                >
                        <Box sx={{ textAlign: "center", mb: 2 }}>
                            <img
                                src={errorIcon}
                                alt="modalIcon"
                                className={NumOtpStyles.img}
                            />
                        </Box>

                        <Typography className={NumOtpStyles.retakeErrorSubTxt}>
                            {retakeError}
                        </Typography>
                    </Box>
                </Grid2> : <Grid2
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: `url(${SignUpBg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        "@media (max-width:600px)": {
                            justifyContent: "start"
                        }
                    }}
                >
                    <Grid2 className={NumOtpStyles.content_wrapper}>

                        <img
                            src={Logo}
                            alt="Logo"
                            className={NumOtpStyles.nav_logo}
                        />
                        <Typography className={NumOtpStyles.heading}>OTP</Typography>
                        <Typography className={NumOtpStyles.sub_title}>
                            Enter OTP sent to {userData?.mobile}
                        </Typography>

                        <form autoComplete="off">
                            <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
                            <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />

                            <Box className={NumOtpStyles.otp_container}>
                                {[...Array(4)].map((_, index) => (
                                    <TextField
                                        key={index}
                                        id={`otp-${index}`}
                                        value={otp[index] || ""}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        inputProps={{
                                            maxLength: 1,
                                            className: NumOtpStyles.otp_input,
                                            type: "tel",
                                            inputMode: "numeric",
                                        }}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "8px",
                                                bgcolor: "white",
                                                width: "94px",
                                                height: "75px",
                                                borderColor: "#ABABAB80 !important",
                                                "& fieldset": {
                                                    borderColor: "#ABABAB80",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "#ABABAB80 !important",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#ABABAB80 !important",
                                                },
                                                "@media (max-width: 550px)": { width: "80px", height: "65px" },
                                                "@media (max-width: 480px)": { width: "70px", height: "60px" },
                                                "@media (max-width: 420px)": { width: "60px", height: "50px" },
                                                "@media (max-width: 360px)": { width: "55px", height: "42px" },
                                            },
                                        }}
                                    />
                                ))}
                            </Box>
                        </form>

                        {clientErr && <Typography color="error" sx={{ marginTop: "20px !important" }}>{clientErr}</Typography>}

                        <Typography
                            sx={{
                                marginTop: "15px",
                                fontWeight: 500,
                                fontSize: "18px", // default (desktop)
                                fontFamily: "Inter400 !important",
                                textAlign: "center",
                                "@media (max-width:600px)": {
                                    fontSize: "16px",
                                },
                                "@media (max-width:480px)": {
                                    fontSize: "14px",
                                },
                                "@media (max-width:360px)": {
                                    fontSize: "12px",
                                },
                            }}
                        >
                            {timeLeft > 0
                                ? `Resend OTP in ${String(Math.floor(timeLeft / 60)).padStart(2, "0")}:${String(timeLeft % 60).padStart(2, "0")}`
                                : <Button onClick={handleResendOtp} sx={{ textTransform: "Capitalize", fontFamily: "Inter400 !important", fontSize: "18px", color: "#000000" }}>Resend Otp</Button>}
                        </Typography>


                        <Grid2 className={NumOtpStyles.button_card}>
                            <Button className={NumOtpStyles.button} onClick={handleOtpSubmit}>
                                {loading ? 'Verifying...' : 'Proceed'}
                            </Button>

                        </Grid2>
                    </Grid2>
                </Grid2>
            }

        </>
    );
}
